//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import magentoIntegrationTemplate from '@legacy-components/ecommerce-integrations/integrations/magento-integration.html';

(function() {
  angular.module('curalate').component('magentoIntegration', {
    bindings: {
      magentoFormValues: '=',
    },
    template: magentoIntegrationTemplate,
  });
})();
